import moment from 'moment';

const states = {
  usage_details: {
    user_engagement_stats: [],
    conversation_log_stats: {
      live_chats: 0,
      need_attentions: 0,
      overtaken_chats: 0,
    },
    chat_session_time_series: [],
    filters: {
      date_range: [moment(new Date(), "DD-MM-YYYY").subtract(1, 'days'), moment(new Date(), "DD-MM-YYYY")],
      platform: "all",
    },
    chat_session_filters: {
      granularity: "day"
    },
    chat_session_scale: {
      count: {
        min: 0
      },
      timestamp: {
        type: 'time',
        tickInterval: 60 * 60 * 1000 * 24 * 2, // 2 day
        mask: 'DD MMM',
        range: [0, 1],
      }
    },
    user_retention: {
      cohorts_columns: [],
      cohorts_data: [],
      retention_filters: {
        granularity: "day"
      }
    },
    loaders: {
      chat_session_loading: false,
      chat_session_load_error: false,
      user_stats_loading: false,
      user_stats_load_error: false,
      user_retention_loading: false,
      user_retention_load_error: false,
    }
  }
};

export default states;



// WEBPACK FOOTER //
// ./src/data/redux/usage_details/states.js